import { createContext } from 'react';
const LicenciasContext = createContext(); 

export default LicenciasContext;